import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
const DynamicBarChart = ({ data, onBarDoubleClick }) => {
    const barConfigs = [
        { dataKey: "AgentText", fill: "var(--chart-agent-text, #374B94)" },
        { dataKey: "BlindTransfer", fill: "var(--chart-blind-transfer, #00abc8)" },
        { dataKey: "Cancel", fill: "var(--chart-cancel, #ff9e18)" },
        { dataKey: "ControlledTransfer", fill: "var(--chart-controlled-transfer, #28a745)" },
        { dataKey: "Disconnect", fill: "var(--chart-disconnect, #a2aaad)" },
        { dataKey: "Email", fill: "var(--chart-email, #17a2b8)" },
        { dataKey: "Error", fill: "var(--chart-error, #e83e8c)" },
        { dataKey: "HandoffTransfer", fill: "var(--chart-handoff-transfer, #ffc107)" },
        { dataKey: "Hangup", fill: "var(--chart-hangup, #6f42c1)" },
        { dataKey: "VoiceMessage", fill: "var(--chart-voice-message, #20c997)" },
    ];
    return (_jsx(ResponsiveContainer, { width: "100%", height: "100%", children: _jsxs(BarChart, { data: data, margin: { top: 5, right: 30, left: 20, bottom: 5 }, children: [_jsx(XAxis, { dataKey: "period", tick: { fontSize: 10 }, interval: 0, angle: -45, textAnchor: "end", height: 60 }), _jsx(YAxis, { tick: { fontSize: 10 } }), _jsx(Tooltip, { animationDuration: 500, content: ({ active, payload, label }) => {
                        if (active && payload && payload.length) {
                            const nonZeroData = payload.filter((entry) => entry.value && typeof entry.value === "number" && entry.value > 0);
                            if (nonZeroData.length === 0)
                                return null;
                            const total = nonZeroData.reduce((sum, entry) => sum + entry.value, 0);
                            return (_jsxs("div", { style: {
                                    backgroundColor: "rgba(255, 255, 255, 0.98)",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    fontSize: "13px",
                                    padding: "12px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                    zIndex: 100,
                                    position: "relative",
                                    minWidth: "200px",
                                }, children: [_jsx("div", { style: {
                                            margin: "0 0 8px 0",
                                            fontWeight: "bold",
                                            color: "var(--ps-blue, #374B94)",
                                            fontSize: "14px",
                                        }, children: label }), _jsxs("div", { style: {
                                            fontSize: "12px",
                                            color: "var(--text-secondary, #666)",
                                            marginBottom: "8px",
                                        }, children: [_jsx("strong", { children: "Total:" }), " ", total.toLocaleString()] }), nonZeroData
                                        .sort((a, b) => b.value - a.value)
                                        .map((entry, index) => {
                                        const percentage = ((entry.value / total) * 100).toFixed(1);
                                        return (_jsx("div", { style: { marginBottom: "4px" }, children: _jsxs("div", { style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }, children: [_jsxs("span", { style: {
                                                            fontWeight: "600",
                                                            color: "var(--text-primary, #333)",
                                                        }, children: [entry.dataKey, ":"] }), _jsxs("span", { style: {
                                                            fontWeight: "bold",
                                                            color: entry.color,
                                                        }, children: [entry.value, " (", percentage, "%)"] })] }) }, index));
                                    })] }));
                        }
                        return null;
                    } }), barConfigs.map((barConfig) => (_jsx(Bar, { dataKey: barConfig.dataKey, stackId: "a", fill: barConfig.fill, onDoubleClick: onBarDoubleClick }, barConfig.dataKey)))] }) }));
};
export default DynamicBarChart;
//# sourceMappingURL=DynamicBarChart.js.map